import { ObjectValues } from '../../app/types/utilityTypes';

export const LID_COMPARISON_EXPORT_TYPES = {
  GENERAL: 0,
  DETAILED: 1,
} as const;

export type LidComparisonExportType = ObjectValues<
  typeof LID_COMPARISON_EXPORT_TYPES
>;
